export default "__VITE_ASSET__0m5MXmf___"